"use client"
import { fetchCategories } from "@/services/category"
import { ComponentConfig } from "@measured/puck"
import { message, Select } from "antd"
import { useEffect, useState } from "react"
import { filterOption } from "../../../../../../lib/external-components"
import { Pagination } from "../../types"
import { PostGridByCategoryProps, RenderConfig } from "./RenderConfig"

const SelectMultiple = ({ value, onChange }: any) => {
  const [optionCategories, setOptionCategories] = useState<{ value: string; label: string }[]>([])

  const fetchCategory = async (paginate?: Pagination, searchTerm?: string) => {
    try {
      const response = await fetchCategories(searchTerm ? { search: searchTerm } : undefined)
      setOptionCategories(
        (response as { data: { id: string; attributes: { name: string } }[] }).data.map(
          (category: { id: string; attributes: { name: string } }) => ({
            value: category.id as string,
            label: category.attributes.name,
          }),
        ),
      )
    } catch (err) {
      message.error("Failed to fetch categories. Please try again.")
    }
  }

  useEffect(() => {
    fetchCategory()
  }, [])

  return (
    <Select
      showSearch
      mode="multiple"
      style={{ minWidth: "14rem" }}
      placeholder="Select Category"
      optionFilterProp="children"
      filterOption={filterOption}
      options={optionCategories}
      allowClear
      value={value}
      onChange={onChange}
    />
  )
}

export const PostGridByCategory: ComponentConfig<PostGridByCategoryProps> = {
  label: "Post Grid By Category",
  fields: {
    idCategory: {
      type: "custom",
      label: "Category ID",
      render: props => <SelectMultiple {...props} />,
    },
  },
  defaultProps: {
    idCategory: [],
  },
  ...RenderConfig,
}
